export enum QnaStage {
  None = 0,
  Start = 1,
  Questions = 2,
  Advice = 3
}
